import { render, staticRenderFns } from "./AzInput.vue?vue&type=template&id=f2ff84b4&scoped=true&"
import script from "./AzInput.vue?vue&type=script&lang=js&"
export * from "./AzInput.vue?vue&type=script&lang=js&"
import style0 from "./AzInput.vue?vue&type=style&index=0&id=f2ff84b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff84b4",
  null
  
)

export default component.exports